<script>
import AoikumoDisabledTooltip from 'dashboard/components/dahreply/AoikumoDisabledTooltip.vue';

export default {
  components: {
    AoikumoDisabledTooltip,
  },
  props: {
    date: { type: String, required: true },
    assignments: { type: Array, default: () => [] },
    readOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedAssignments: [],
      isDeleting: false,
    };
  },
  computed: {
    assignmentsForDate() {
      return this.assignments.filter(a => {
        return a.startDate <= this.date && (!a.endDate || a.endDate >= this.date);
      });
    },
    allSelected: {
      get() {
        return this.assignmentsForDate.length > 0 &&
               this.selectedAssignments.length === this.assignmentsForDate.length;
      },
      set(value) {
        if (value) {
          this.selectedAssignments = this.assignmentsForDate.map(a => a.id);
        } else {
          this.selectedAssignments = [];
        }
      }
    }
  },
  methods: {
    getEventTitle(assignment) {
      const staff =
        this.$store.state.staffOptions.allOptions?.find(o => o.staff.id === assignment.staffId)?.staff?.name
        || assignment.staffName
        || 'Staff';

      const branch =
        this.$store.state.branchV2.allBranches?.find(b => b.branch.id === assignment.branchId)?.branch?.name
        || assignment.branchName
        || 'Branch';

      return `${staff} @ ${branch}`;
    },

    async handleBulkDelete() {
      if (!this.selectedAssignments.length) return;
      this.isDeleting = true;
      try {
        await this.$store.dispatch('assignments/bulkDelete', {
          ids: this.selectedAssignments
        });
        this.selectedAssignments = [];
        // Close panel if no assignments left for this date
        if (this.assignmentsForDate.length === 0) {
          this.$emit('close');
        }
      } catch (err) {
        console.error('Failed to delete assignments:', err);
      } finally {
        this.isDeleting = false;
      }
    },

    handleAssignmentClick(assignment) {
      if (this.readOnly) return;
      this.$emit('edit', assignment.id);
    }
  }
}
</script>

<template>
  <div class="flex-none w-80 max-w-[20rem] p-4 overflow-auto border-r border-slate-200 dark:border-slate-700">
    <!-- Header -->
    <div class="flex justify-between items-center mb-2">
      <h3 class="text-lg font-semibold">{{ date }}</h3>
      <woot-button icon="dismiss" variant="clear" color-scheme="alert" @click="$emit('close')" size="sm" />
    </div>

    <!-- Actions -->
    <AoikumoDisabledTooltip :disabled="readOnly" class="mb-2 flex gap-2 items-center">
      <input
        type="checkbox"
        id="select-all"
        :disabled="readOnly"
        :checked="allSelected"
        @change="allSelected = $event.target.checked"
      />
      <label for="select-all" class="text-sm">Select All</label>

      <woot-button
        icon="trash"
        :disabled="!selectedAssignments.length || isDeleting || readOnly"
        @click="handleBulkDelete"
        size="sm"
      >
        Delete Selected
      </woot-button>
    </AoikumoDisabledTooltip>

    <!-- Assignment List -->
    <ul class="space-y-2">
      <li
        v-for="assignment in assignmentsForDate"
        :key="assignment.id"
        class="flex items-center justify-between border-b py-1 hover:bg-slate-50 dark:hover:bg-slate-700 rounded cursor-pointer"
      >
        <AoikumoDisabledTooltip :disabled="readOnly" class="text-sm truncate max-w-[calc(100%-2rem)] flex-1">
          <div @click="handleAssignmentClick(assignment)">
            {{ getEventTitle(assignment) }}
          </div>
        </AoikumoDisabledTooltip>
        <input
          type="checkbox"
          :value="assignment.id"
          :disabled="readOnly"
          v-model="selectedAssignments"
          @click.stop
        />
      </li>
    </ul>
  </div>
</template>